import { getQueryParametersFromUrl } from "./urlHelper";

const getVatInclusivity = (defaultVatIncl: boolean): boolean => {
  const pcxtVatInclusiveQueryParam = getVatInclusivityFromPcxtParam();
  if (pcxtVatInclusiveQueryParam !== undefined) {
    return pcxtVatInclusiveQueryParam;
  }

  const doc = getDocument();
  return pricingContextIsInitialized() ? doc?.pcxtV3?.isVatInclusive() : defaultVatIncl;
};

const getVatInclusivityFromPcxtParam = () => {
  const pcxtVatInclusiveQueryParam = getPcxtVatInclusiveQueryParam();
  if (pcxtVatInclusiveQueryParam !== undefined) {
    if (pcxtVatInclusiveQueryParam.toLowerCase() == "true") {
      return true;
    } else if (pcxtVatInclusiveQueryParam.toLowerCase() == "false") {
      return false;
    }
  }
  return undefined;
};

const getPcxtVatInclusiveQueryParam = () => {
  const queryParams = getQueryParametersFromUrl();
  return queryParams.PCXTVATINCLUSIVE;
};

const getPricingContextEncodedString = (): string => {
  const doc = getDocument();
  return doc?.pcxtV3?.getEncodedContextString() ?? "";
};

const getPricingContextAsQueryString = (): string => {
  const doc = getDocument();
  return doc?.pcxtV3?.getContextAsQueryString() ?? "";
};

const initializePricingContext = async (
  tenant: string,
  country: string,
  developmentMode?: boolean
) => {
  const doc = getDocument();
  await doc?.pcxtV3?.init(tenant, country, developmentMode);
};

const pricingContextIsInitialized = (): boolean => {
  const doc = getDocument();
  return doc?.pcxtV3?.isInitialized() ?? false;
};

const getDocument = (): any => {
  return typeof document !== "undefined" ? document : undefined;
};

export {
  getVatInclusivity,
  getVatInclusivityFromPcxtParam,
  getPricingContextEncodedString,
  getPricingContextAsQueryString,
  initializePricingContext,
  pricingContextIsInitialized,
};
